import SocialMedia from "components/About/SocialMedia";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import DiscussMaria from "components/Insights/DiscussMaria";
import HeroInsight from "components/Insights/HeroInsight";
import ListInsight from "components/Insights/ListInsight";
import MissionInsight from "components/Insights/MissionInsight";
import React from "react";

export const Insight = () => {
  return (
    <div>
      <HeroInsight />
      <MissionInsight />
      <ListInsight />
      <DiscussMaria />
    </div>
  );
};
